// extracted by mini-css-extract-plugin
export default {"cocorico":"vEsdL","frenchFlag":"qo_Zj"};